import React, { useContext, useState } from "react";
import styled from "styled-components";
import * as Yup from "yup";
import { Theme } from "@literati/public-ui-shared-react";
import { Subscription } from "lib/api/subscription";
import LegacyThemeProvider from "components/Layout/DefaultThemeProvider";
import {
  BudgetSubmit,
  BudgetValues,
  BudgetKey as Key,
  BudgetKey,
} from "components/Step/stepTypes";
import StepLayout, { StepLayoutProps } from "components/Step/StepLayout";
import {
  getContentfulQuizStep,
  gsuSubmitAnswersDefault,
} from "components/Step/stepUtil";
import GuidedSignUpLayoutRadio from "components/GuidedSignUp/GuidedSignUpLayoutRadio";
import { useRouter } from "next/router";
import { facebookPixelTrackBudgetValueResponse } from "utils/facebook/facebookPixelTrackEvent";
import { AuthContext } from "contexts/AuthProvider";

export const VALIDATION_SCHEMA = Yup.object().shape({
  [Key.BUDGET]: Yup.string().required("Required."),
});

export const INITIAL_VALUES: BudgetValues = {
  [Key.KIND]: "budget",
  [Key.BUDGET]: "",
} as const;

export function getReadingLevelStep(contentfulQuizModel?: any) {
  const step = getContentfulQuizStep(contentfulQuizModel, "reader-budget");
  return step;
}

const StyledGuidedSignUpLayoutRadio = styled(GuidedSignUpLayoutRadio)`
  padding: 2rem 0;
`;

export type StepLayoutPropsBudget = Omit<
  StepLayoutProps<BudgetValues>,
  "asForm" | "children" | "formId"
>;

export interface StepBudgetProps extends StepLayoutPropsBudget {
  childName?: string;
  contentfulQuizModelParsed?: any;
  initialValues?: Partial<BudgetValues> | null;
  onSubmit: BudgetSubmit;
  subscription?: Subscription;
}

export const StepBudget = ({
  childName,
  contentfulQuizModelParsed,
  initialValues: initialValuesProp,
  onSubmit,
  subscription,
  ...stepLayoutProps
}: StepBudgetProps) => {
  const { user } = useContext(AuthContext);
  const router = useRouter();
  const [initialValues] = useState<BudgetValues>({
    ...INITIAL_VALUES,
    ...initialValuesProp,
  });

  const [step] = useState(getReadingLevelStep(contentfulQuizModelParsed));

  const handleSubmit: BudgetSubmit = async (values, formikHelpers) => {
    const answer = values[BudgetKey.BUDGET];
    if (answer !== "[0, 0]") {
      facebookPixelTrackBudgetValueResponse({
        url: router?.route,
        userId: (user as any)?.id,
      });
    }
    return await gsuSubmitAnswersDefault({
      contentfulQuizModel: contentfulQuizModelParsed,
      formikHelpers,
      onError: (res) => res, // @TODO
      onSubmit,
      step,
      subscription,
      values,
    });
  };

  return (
    <Theme>
      <StepLayout<BudgetValues>
        asForm
        bgColor="white"
        formId="activation-step-budget"
        formikProps={{
          initialValues,
          onSubmit: handleSubmit,
          validationSchema: VALIDATION_SCHEMA,
        }}
        {...stepLayoutProps}
      >
        <LegacyThemeProvider>
          <StyledGuidedSignUpLayoutRadio step={step} childName={childName} />
        </LegacyThemeProvider>
      </StepLayout>
    </Theme>
  );
};

export default StepBudget;
